
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/sailpoint-alternative",
      function () {
        return require("private-next-pages/compare/sailpoint-alternative.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/sailpoint-alternative"])
      });
    }
  